export default (function ({ store, redirect }) {
    const magicLink = store.state.authentication.magicLink;
    if (!magicLink)
        return;
    return redirect('/declaration');
});
